import moment from "moment";
import xhrCaller from "./xhr-caller";

export const xhrClinicalSearchExam = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/SearchExams`,
		data,
	});
	return result;
};

export const xhrClinicalSearchExamRef = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/SearchExamsReferring`,
		data,
	});
	return result;
};

export const ClinicalSearchExamDataFromFilter = (
	filterObj,
	pageNumber,
	pageRecord
) => {
	let paramObj = {
		pr: pageRecord,
		pi: pageNumber,
	};

	if (filterObj?.t && filterObj?.t.length > 0) {
		paramObj["t"] = filterObj?.t.join(",");
	}

	if (filterObj?.i && filterObj?.i.length > 0) {
		paramObj["i"] = filterObj?.i.join(",");
	}

	if (filterObj?.rf && filterObj?.rf.length > 0) {
		paramObj["rf"] = filterObj?.rf.join(",");
	}

	if (filterObj?.m && filterObj?.m.length > 0) {
		paramObj["m"] = filterObj?.m.join(",");
	}

	if (filterObj?.es && filterObj?.es.length > 0) {
		paramObj["es"] = filterObj?.es.join(",");
	}

	if (!(filterObj?.dr?.length > 0)) {
		filterObj.dr = "1M";
	}
	if (filterObj?.dr === "custom") {
		let customDaysShift = 0;
		paramObj["sdt"] = filterObj?.sdt;
		paramObj["edt"] = filterObj?.edt;
		try {
			customDaysShift = Math.floor(
				(Date.parse(filterObj?.edt) - Date.parse(filterObj?.sdt)) / 86400000
			);
			if (customDaysShift > -100000) {
				const cusEdtMoment = moment(Date.parse(filterObj?.edt))
					.subtract(-customDaysShift * filterObj?.dts, "days")
					.endOf("day");
				paramObj["edt"] = cusEdtMoment.format("YYYY-MM-DD hh:mm:ss");
				const cusSdtMoment = cusEdtMoment
					.subtract(customDaysShift, "days")
					.startOf("day");
				paramObj["sdt"] = cusSdtMoment.format("YYYY-MM-DD hh:mm:ss");
			}
		} catch {}
	} else if (filterObj?.dr ?? "1M") {
		let startDateString = "";
		let endDateString = "";

		let valueEnd = 0;
		let value = 0;
		let type;
		filterObj.dts = filterObj?.dts ?? 0;
		switch (filterObj?.dr) {
			case "1D":
				value = 1;
				valueEnd = -(1 * filterObj.dts);
				type = "days";
				break;
			case "5D":
				value = 5;
				valueEnd = -(5 * filterObj.dts);
				type = "days";
				break;
			case "15D":
				value = 15;
				valueEnd = -(15 * filterObj.dts);
				type = "days";
				break;
			case "1M":
				value = 1;
				valueEnd = -(1 * filterObj.dts);
				type = "months";
				break;
			case "2M":
				value = 2;
				valueEnd = -(2 * filterObj.dts);
				type = "months";
				break;
			case "4M":
				value = 4;
				valueEnd = -(4 * filterObj.dts);
				type = "months";
				break;
			default:
				break;
		}

		if (value > 0) {
			const endDateMoment = moment()
				.utc()
				.subtract(valueEnd, type)
				.endOf("day");
			endDateString = endDateMoment.format("YYYY-MM-DD hh:mm:ss");
			const startDateMoment = endDateMoment
				.subtract(type === "months" ? value : value - 1, type)
				.startOf("day");
			startDateString = startDateMoment.format("YYYY-MM-DD hh:mm:ss");

			if (startDateString && startDateString.length > 0) {
				paramObj["sdt"] = startDateString ?? "";
			}

			if (endDateString && endDateString.length > 0) {
				paramObj["edt"] = endDateString ?? "";
			}
		}
	}

	if (filterObj?.sn !== "") {
		paramObj["sn"] = filterObj?.sn;
	}

	if (filterObj?.si !== "") {
		paramObj["si"] = filterObj?.si;
	}

	if (filterObj?.srt) {
		paramObj["srt"] = filterObj?.srt;
	}

	if (filterObj?.srd) {
		paramObj["srd"] = filterObj?.srd;
	}

	paramObj["o"] = filterObj?.o ?? true;

	if (filterObj?.ute) {
		paramObj["ute"] = filterObj?.ute;
	}

	if (filterObj?.ura) {
		paramObj["ura"] = filterObj?.ura;
	}

	if (filterObj?.uty) {
		paramObj["uty"] = filterObj?.uty;
	}

	if (filterObj?.himg !== null || filterObj?.himg !== undefined) {
		paramObj["himg"] = filterObj?.himg;
	}

	if (filterObj?.haud !== null || filterObj?.haud !== undefined) {
		paramObj["haud"] = filterObj?.haud;
	}

	if (filterObj?.htxt !== null || filterObj?.htxt !== undefined) {
		paramObj["htxt"] = filterObj?.htxt;
	}

	if (filterObj?.hreq !== null || filterObj?.hreq !== undefined) {
		paramObj["hreq"] = filterObj?.hreq;
	}
	return paramObj;
};

export const xhrClinicalGetPatHistoryExamsRef = async (
	token,
	id,
	sortBy,
	sortDirection
) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetPatHistoryExamsRef?id=${id}&srt=${sortBy}&srd=${sortDirection}`,
	});
	return result;
};

export const xhrClinicalGetExamStudyByExamId = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetExamStudyByExamId?id=${id}`,
	});
	return result;
};

export const xhrClinicalGetBundledExamsByExamId = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetBundledExamsByExamId?id=${id}`,
	});
	return result;
};

export const xhrClinicalGetExamNoteByExamId = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetExamNoteByExamId?id=${id}`,
	});
	return result;
};

export const xhrClinicalGetExamFavorite = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetExamFavorite?id=${id}`,
	});
	return result;
};

export const xhrClinicalSetExamFavorite = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		data,
		method: "post",
		action: `Clinical/SetExamFavorite`,
	});
	return result;
};

export const xhrClinicalGetReportViewById = async (token, reportId) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetReportViewById?id=${reportId}`,
	});
	return result;
};

export const xhrClinicalSetExamDeliveryDate = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/SetExamDeliveryDate`,
	});
	return result;
};

export const xhrClinicalGetExamViewById = async (token, id) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetExamViewById?id=${id}`,
	});
	return result;
};

export const xhrClinicalGetExamsByUniqueIds = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		data,
		action: `Clinical/GetExamsByUniqueIds`,
	});
	return result;
};

export const xhrClinicalGetPatHistoryExamsByStatus = async (
	token,
	id,
	statusArray
) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: `Clinical/GetPatHistoryExamsByStatus?id=${id}&status=${statusArray}`,
	});
	return result;
};

export const xhrClinicalShareExam = async (token, data) => {
	var result = await xhrCaller({
		bearer: token,
		srv: "api",
		action: "Clinical/ShareExam",
		method: "post",
		data,
	});
	return result;
};
